import React from 'react'

function LoadingMessage() {
    var audio = new Audio('https://nightkeepers.r0491.com/TypeSE_c_single.mp3');
	audio.volume = 0.2;
    audio.play();
    return(
        <div className="single-message--loading">
            <div id="dot-1" className="single-message--loading__dots"></div>
            <div id="dot-2" className="single-message--loading__dots"></div>
            <div id="dot-3" className="single-message--loading__dots"></div>
        </div>
    );
}

export default LoadingMessage;
